import { render, staticRenderFns } from "./OrderRegistration.vue?vue&type=template&id=a8328cf8&"
import script from "./OrderRegistration.vue?vue&type=script&lang=js&"
export * from "./OrderRegistration.vue?vue&type=script&lang=js&"
import style0 from "./OrderRegistration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports